import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Divider, HStack, Input, ModalBody, Stack, Switch } from '@chakra-ui/react';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import GiveawayModalHeader from './GiveawayModalHeader';
import { GiveawayModalContext } from './GiveawayModalContext';
import { GiveawaySteps } from '@/types/client';
import useGiveawayStore from '@/stores/GiveawayStore';
import SettingsPanel from '../SettingsPanel';
import { useShallow } from 'zustand/react/shallow';
export default function GiveawayKeywordStep() {
    var intl = useIntl();
    var _React_useContext = React.useContext(GiveawayModalContext), onClose = _React_useContext.onClose, setStep = _React_useContext.setStep, onComplete = _React_useContext.onComplete;
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            phrase: state.phrase,
            setPhrase: state.setPhrase,
            preventPhraseSpam: state.preventPhraseSpam,
            setPreventPhraseSpam: state.setPreventPhraseSpam,
            uniqueWinners: state.uniqueWinners,
            setUniqueWinners: state.setUniqueWinners
        };
    })), phrase = _useGiveawayStore.phrase, setPhrase = _useGiveawayStore.setPhrase, preventPhraseSpam = _useGiveawayStore.preventPhraseSpam, setPreventPhraseSpam = _useGiveawayStore.setPreventPhraseSpam, uniqueWinners = _useGiveawayStore.uniqueWinners, setUniqueWinners = _useGiveawayStore.setUniqueWinners;
    return /*#__PURE__*/ _jsxs(ModalBody, {
        padding: 0,
        children: [
            /*#__PURE__*/ _jsx(GiveawayModalHeader, {
                title: intl.formatMessage({
                    id: "S8kqP9",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Conditions"
                        }
                    ]
                }),
                onClose: onClose
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 6,
                padding: 6,
                children: [
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        flexDir: "column",
                        alignItems: "baseline",
                        heading: intl.formatMessage({
                            id: "fe0rMF",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Keyword"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "/KSAaz",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "The phrase that users must type to enter the giveaway."
                                }
                            ]
                        }),
                        afterElementContainerProps: {
                            maxWidth: '100%'
                        },
                        afterElement: /*#__PURE__*/ _jsx(Input, {
                            placeholder: intl.formatMessage({
                                id: "QMgO7V",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Enter keyword"
                                    }
                                ]
                            }),
                            value: phrase,
                            onChange: function(e) {
                                return setPhrase(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: intl.formatMessage({
                            id: "id+jtl",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Anti-Spam"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "nG2Edg",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Exclude users who attempt to enter multiple times."
                                }
                            ]
                        }),
                        afterElementContainerProps: {
                            width: 'fit-content'
                        },
                        afterElement: /*#__PURE__*/ _jsx(Switch, {
                            colorScheme: "primary",
                            isChecked: preventPhraseSpam,
                            onChange: function(e) {
                                return setPreventPhraseSpam(e.target.checked);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: intl.formatMessage({
                            id: "UnFLxJ",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Unique Winners"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "uQ/BeF",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "This will exclude users who have already won this session."
                                }
                            ]
                        }),
                        afterElementContainerProps: {
                            width: 'fit-content'
                        },
                        afterElement: /*#__PURE__*/ _jsx(Switch, {
                            colorScheme: "primary",
                            isChecked: uniqueWinners,
                            onChange: function(e) {
                                return setUniqueWinners(e.target.checked);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {
                borderColor: "borderSecondary"
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                spacing: 6,
                p: 6,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        flex: 1,
                        onClick: function() {
                            return setStep(GiveawaySteps.ELIGIBILITY);
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "cyR7Kh",
                            defaultMessage: "Back"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        flex: 1,
                        variant: "cta",
                        onClick: function() {
                            onClose();
                            onComplete();
                        },
                        isDisabled: phrase.length === 0,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "JXdbo8",
                            defaultMessage: "Done"
                        })
                    })
                ]
            })
        ]
    });
}
